import React, { useState } from 'react';
// import { createApp } from '../services/appService'; // No longer used directly
import { useCreateApp } from '../services/appService'; // Import the hook
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

function AddAppModal({ open, onClose, onAppAdded }) {
  const [appName, setAppName] = useState('');
  const [supabaseUrl, setSupabaseUrl] = useState('');
  const [supabaseKey, setSupabaseKey] = useState('');
  const [pgHost, setPgHost] = useState('');
  const [pgPort, setPgPort] = useState('5432');
  const [pgUser, setPgUser] = useState('postgres');
  const [pgPassword, setPgPassword] = useState('');
  const [pgDbname, setPgDbname] = useState('postgres');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const createAppHook = useCreateApp(); // Use the hook

  const resetForm = () => {
    setAppName('');
    setSupabaseUrl('');
    setSupabaseKey('');
    setPgHost('');
    setPgPort('5432');
    setPgUser('postgres');
    setPgPassword('');
    setPgDbname('postgres');
    setError('');
    setLoading(false);
  }

  const handleClose = () => {
    resetForm();
    onClose(); // Call the parent onClose handler
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');

    const appData = {
      name: appName,
      supabase_url: supabaseUrl,
      supabase_service_role_key: supabaseKey,
      pg_host: pgHost || null, // Send null if empty
      pg_port: pgPort ? parseInt(pgPort, 10) : null,
      pg_user: pgUser || null,
      pg_password: pgPassword || null,
      pg_dbname: pgDbname || null,
    };

    try {
      // await createApp(appData); // Old direct call
      await createAppHook(appData); // Call the hook's function
      onAppAdded(); // Notify parent component
      handleClose(); // Close modal on success
    } catch (err) {
      console.error("Error creating app:", err);
      setError(err.message || 'Failed to create app. Please check details and try again.');
      setLoading(false); // Keep modal open on error
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} >
      <DialogTitle>Add New Application</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{mb: 2}}>
          Enter the details for the Supabase application you want to manage.
          Provide both Supabase and direct PostgreSQL connection details.
        </DialogContentText>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
           <TextField
                margin="normal"
                required
                fullWidth
                id="appName"
                label="Application Name"
                name="appName"
                autoComplete="organization-title"
                autoFocus
                value={appName}
                onChange={(e) => setAppName(e.target.value)}
                disabled={loading}
            />
             <TextField
                margin="normal"
                required
                fullWidth
                id="supabaseUrl"
                label="Supabase URL"
                name="supabaseUrl"
                autoComplete="url"
                value={supabaseUrl}
                onChange={(e) => setSupabaseUrl(e.target.value)}
                 disabled={loading}
                 placeholder="e.g., https://your-project-ref.supabase.co"
            />
            <TextField
                margin="normal"
                required
                fullWidth
                name="supabaseKey"
                label="Supabase Service Role Key"
                type="password"
                id="supabaseKey"
                autoComplete="current-password" // Or off if preferred
                value={supabaseKey}
                onChange={(e) => setSupabaseKey(e.target.value)}
                disabled={loading}
                helperText="The JWT token starting with eyJ... (NOT the Postgres password)"
            />
            <Typography variant="subtitle1" sx={{ mt: 3, mb: 1}}>PostgreSQL Details</Typography>
             <Grid container spacing={2}>
                <Grid item xs={12} sm={8}>
                    <TextField
                        margin="dense" // Use dense margin in grid
                        fullWidth
                        id="pgHost"
                        label="Postgres Host"
                        name="pgHost"
                        value={pgHost}
                        onChange={(e) => setPgHost(e.target.value)}
                        disabled={loading}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                     <TextField
                        margin="dense"
                        fullWidth
                        id="pgPort"
                        label="Port"
                        name="pgPort"
                        type="number"
                        value={pgPort}
                        onChange={(e) => setPgPort(e.target.value)}
                        disabled={loading}
                    />
                </Grid>
                 <Grid item xs={12} sm={6}>
                     <TextField
                        margin="dense"
                        fullWidth
                        id="pgDbname"
                        label="Database Name"
                        name="pgDbname"
                        value={pgDbname}
                        onChange={(e) => setPgDbname(e.target.value)}
                        disabled={loading}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                     <TextField
                        margin="dense"
                        fullWidth
                        id="pgUser"
                        label="User"
                        name="pgUser"
                        value={pgUser}
                        onChange={(e) => setPgUser(e.target.value)}
                        disabled={loading}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        margin="dense"
                        fullWidth
                        name="pgPassword"
                        label="Password"
                        type="password"
                        id="pgPassword"
                        autoComplete="new-password" // Help browser save if desired
                        value={pgPassword}
                        onChange={(e) => setPgPassword(e.target.value)}
                        disabled={loading}
                    />
                </Grid>
             </Grid>
            
        </Box>
      </DialogContent>
      <DialogActions sx={{ pb: 3, px: 3}}>
        <Button onClick={handleClose} disabled={loading}>Cancel</Button>
        <Button type="submit" variant="contained" onClick={handleSubmit} disabled={loading}>
           {loading ? <CircularProgress size={24} /> : 'Add App'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddAppModal; 